import PropTypes from 'prop-types';

export const requestParamsType = PropTypes.shape({
  airline  : PropTypes.string,
  service  : PropTypes.string,
  cityCode : PropTypes.string,
  limitDate: PropTypes.string,
});

export const datesObjType = PropTypes.objectOf(
  PropTypes.arrayOf(
    PropTypes.shape({
      from: PropTypes.string,
      to  : PropTypes.string,
    }),
  ),
);

export const fieldType = PropTypes.shape({
  name : PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
});

export const formType = PropTypes.shape({
  setFieldValue: PropTypes.func,
  values       : PropTypes.objectOf(PropTypes.any),
});
